import { HotelConfiguration } from '../../hooks/useHotelConfig/useHotelConfig';
import { Waypoint } from '../../types/Booking';
import { TomTomApiResult } from '../../types/TomTom/TomTomApiResult';

export const formatKioskToWaypoint = (kiosk: HotelConfiguration): Waypoint => {
  return {
    lat: kiosk.data?.lat,
    lng: kiosk.data?.lng,
    address: kiosk.data?.address,
    postcode: kiosk.data?.postcode,
  };
};

export const formatTomTomApiResultToWaypoint = (res?: TomTomApiResult): Waypoint => {
  if (!res) return {};

  const reducedPostalCode = res.address.extendedPostalCode?.split(',').length > 1;
  return {
    postcode:
      reducedPostalCode || !res.address.extendedPostalCode
        ? res.address.postalCode.split(',')[0] //catch for mutiple postalCodes
        : res.address.extendedPostalCode,
    address: res.address.freeformAddress,
    lat: res.position.lat,
    lng: res.position.lon,
  };
};
